import sortBy from 'lodash/sortBy';
import { TFunction } from 'i18next';

import {
  TOPIC_STATUS_DRAFT,
  TOPIC_STATUS_FUTURE,
  UNIT_STATUS_COMING_SOON,
  UNIT_STATUS_DRAFT,
} from 'global/constants';
import { getContentNumber } from 'approot/shared/logic/get-content-number';
import { ContentNavItems, ContentNavItem } from './content-page-nav.constants';
import {
  getFocusLabel,
  getUnitLabel,
} from 'approot/shared/logic/content-label';

export function getRelevantLinks(
  itemList: ContentNavItems[] | undefined,
  isIntegrated: boolean
) {
  return sortBy(itemList, isIntegrated ? 'integratedSort' : 'sort').filter(
    u => {
      if (u.__typename === 'Unit') {
        return u.unitStatus !== UNIT_STATUS_DRAFT;
      }
      return true;
    }
  );
}

export function getLinkDisabledState(item: ContentNavItems) {
  if (item.__typename === 'Topic') {
    return (
      item.topicStatus === TOPIC_STATUS_FUTURE ||
      item.topicStatus === TOPIC_STATUS_DRAFT
    );
  } else if (item.__typename === 'Unit') {
    return item.unitStatus === UNIT_STATUS_COMING_SOON;
  }
}

export function getLinkLabel(
  item: ContentNavItems,
  items: ContentNavItems[] | undefined,
  t: TFunction
) {
  switch (item.__typename) {
    case 'Topic':
      return item.topicStatus === TOPIC_STATUS_DRAFT
        ? 'Draft'
        : item.topicStatus === TOPIC_STATUS_FUTURE
        ? 'Future'
        : `${getFocusLabel(t)}${
            items ? ` ${getContentPosition(item, items)}` : ''
          }`;
    case 'Unit':
      return item.unitStatus === UNIT_STATUS_COMING_SOON
        ? 'Coming Soon'
        : `${getUnitLabel(t)}${
            items ? ` ${getContentPosition(item, items)}` : ''
          }`;
    case 'Assessment':
      return 'Assessment';
    default:
      return `${item.__typename}${
        items ? ` ${getContentPosition(item, items)}` : ''
      }`;
  }
}

function getContentPosition(item: ContentNavItems, items: ContentNavItems[]) {
  return (
    items
      .filter(a => a.__typename !== 'Assessment')
      .findIndex(i => i.id === item.id) + 1
  );
}

export function getItemTypeLabel(
  item: ContentNavItem,
  items: ContentNavItems[],
  isIntegrated: boolean,
  t: TFunction
) {
  if (item.label === 'Lesson') {
    const lessons = items.filter(i => i.__typename !== 'Assessment');
    return `${item.label} ${getContentNumber(item.id, isIntegrated, lessons)}`;
  } else if (item.label === getUnitLabel(t)) {
    return `${item.label} ${getContentNumber(item.id, isIntegrated, items)}`;
  }
  return item.label;
}
